<template>
  <!-- 拼多多二跳 -->
  <div ref="box" class="maxwidht">
    <div class="defaultImg" @click="submitCodeForm">
      <img :src="currentObj.link_img" alt="">
    </div>

    <!-- <div>clickid:{{$route.query.clickid}}</div>
    <div>creativeid:{{$route.query.creativeid}}</div>
    <div>creativetype:{{$route.query.creativetype}}</div>
    <div>adid:{{$route.query.adid}}</div>
    <div>{{decodeURIComponent(currentObj.mobile_url)}}</div> -->

    <div class="padding" v-if="currentObj.recommend==1">
      <div class="text-center">
        <h3>相关推荐</h3>
      </div>
      <div class="grid col-2 col-gap">
        <div class="margin-top border" v-for="(item,index) in goodsList" :key="index" @click="openrecommed(item)">
          <div>
            <img style="width: 100%;" :src="item.goods_image_url"/>
          </div>
          <div class="margin-left">
            <div class="retract">{{item.goods_name}}</div>
            <div class="margin-top text-red">￥<span>{{item.min_normal_price/100}}</span>元</div>
          </div>
        </div>
      </div>
    </div>
    <div class="center">{{ currentObj.company_info }}</div>
    <div style="height: 95px;"></div>
    <div class="button" @click="submitCodeForm">
      点击查看详情
    </div>
  </div>
</template>

<script src="../utils/jquery.js"></script>
<script>
import { getPagePddInfo,submitCode,submitJump,getPagePddInfoBd} from "../utils/api"
import CryptoJS from "crypto-js";
export default {
  name: 'shadows',
  data() {
    return {
      currentObj:{},
      defaultImg: [],
      goodsList:[]
    }
  },
  created() {
    this.getPageDetail()
  },
  mounted(){

  },
  methods: {
    //跳转拼多多并提交code
    submitCodeForm(){
      let params = {
        code_id:this.encrypt(this.currentObj.landing_page_info_code)
      }

      // let pdd_url =this.currentObj.mobile_url.replace('__CID__',this.$route.query.creativeid)
      // .replace('__CLICKID__',this.$route.query.adid)
      // .replace('__AID__',this.$route.query.clickid)
      // .replace('__CTYPE__',this.$route.query.creativetype)


      submitCode(params).then(res=>{
        if(this.currentObj.jump_schema==1){
          window.open(this.currentObj.schema_url,"_self")
        }else{
          window.open(this.currentObj.mobile_url,"_self")
        }
      })
    },
    openrecommed(row){

      let params = {
        landingpage:this.encrypt(this.currentObj.landing_page_info_code),
        goods_name:this.currentObj.goods_name,
        goods_id:row.goods_id,
        goods_name_jump:row.goods_name
      }
      submitJump(params).then(res=>{
        if(this.currentObj.jump_schema==1){
          window.open(row.schema_url,"_self")
        }else{
          window.open(row.mobile_url,"_self")
        }
      })
    },
    //获取页面详情
    getPageDetail() {
      let codeId=this.$route.query.code_id
      let encryptCode = this.encrypt(codeId)
      if (encryptCode) {
        let param={
          code_id: encryptCode,
          pass:"false",
          dencrypt_time:this.encrypt((Date.parse(new Date())/1000).toString()),
          adid:this.$route.query.adid,
          creativeid:this.$route.query.creativeid,
          creativetype:this.$route.query.creativetype,
          bd_vid:this.$route.query.bd_vid,

        }
        getPagePddInfoBd(param).then(res => {
          this.currentObj = res.data
          this.goodsList = res.data.shop_info
          document.title = this.currentObj.title
          // this.defaultImg = this.currentObj.picture_src.split(",")
        }, err => {
        })
      }
    },
    //获取url参数
    getRequestParam(key) {
      var url = window.location.href
      let pattern = /(\w+)=(\w+)/ig; //定义正则表达式
      let parames = {}; // 定义参数对象
      url.replace(pattern, ($, $1, $2) => {
        parames[$1] = $2;
      });
      return parames;
    },
    //加密
    encrypt(text) {
      var key = CryptoJS.enc.Utf8.parse('1463587320654321'); //为了避免补位，直接用16位的秘钥
      var iv = CryptoJS.enc.Utf8.parse('1758326540123456'); //16位初始向量
      var encrypted = CryptoJS.AES.encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    }
  }
}
</script>

<style scoped>
.maxwidht {
  max-width: 500px;
  margin: 0 auto;
}
.defaultImg,.defaultImg img {
  width: 100%;
  display: flex;
}
.center {
  text-align: center;
}
.button {
  max-width: 500px;
  width: 100%;
  line-height: 80px;
  position: fixed;
  bottom: 0;
  border: none;
  font-size: 20px;
  font-weight: bold;
  color: white;
  text-align: center;
  background-image: url('../assets/btn.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.flex{
  display: flex;
}
.padding{
  padding: 10px;
}
.margin-top{
  margin-top: 10px;
}
.margin-left{
  margin-left: 10px;
}
.relative{
  position: relative;
}
.abso-bootom{
  position: absolute;
  bottom: 0;
  color: red;
}
.text-red{
  color: red;
}
.grid{
  display: grid;
}
.col-2{
  grid-template-columns: 1fr 1fr;
}
.col-gap{
  grid-gap: 10px;
}
.retract {
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
  .border{
    border: 1px solid #82a3a8;
    border-radius: 5px;
  }
  .text-center{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/bdShadow.vue